// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"066f083f","408":"fbf3271c","787":"edf89ee1"}[chunkId] + ".chunk.js";
};